import React from 'react';
import { formatCpf } from '../utils/cpfMask';

interface CpfInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string;
  onChange: (value: string, rawValue: string) => void;
}

export const CpfInput: React.FC<CpfInputProps> = ({
  value,
  onChange,
  ...props
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\D/g, '');
    const formatted = formatCpf(e.target.value);
    onChange(formatted, raw);
  };

  return (
    <input
      {...props}
      type="text"
      value={value}
      onChange={handleChange}
      placeholder={props.placeholder || '000.000.000-00'}
      maxLength={14}
    />
  );
};
